import React from 'react'
import intl from 'react-intl-universal'
import triggerEvent from 'utils/dataLayer'

import AuthenticatedLink from 'components/molecules/AuthenticatedLink'

const StartTestLink = () => (
  <AuthenticatedLink
    href="/aptitude_test/instruction"
    successUrl="/aptitude_test/instruction"
    className="aptitude-landing-start-btn"
    onClick={() => { triggerEvent('ga/aptitudetest/home') }}
  >
    {intl.get('aptitude.landing.test_now')}
    <style jsx global>
      {`
        .aptitude-landing-start-btn {
          width: 100%;
          display: inline-block;
          padding: 14px 24px;
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          color: #fff;
          border-radius: 4px;
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
          background-color: #fc7d20;
          &:hover {
            text-decoration: none;
            color: #fff;
            background-color: #ce3f04;
          }
          @media screen and (min-width: 768px) {
            width: unset;
          }
        }
      `}
    </style>
  </AuthenticatedLink>
)

export default StartTestLink
